// extracted by css-extract-rspack-plugin
export default {"wrapper":"HelpModalContactPhone-module__wrapper--HzhWa"};